import { LoadingIndicator } from "@abb/arcadia-ui-react"

export function DiMaProgress() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <LoadingIndicator variant="lazy-load" size="medium" />
    </div>
  )
}
